"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./badge.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BadgeComponent = function BadgeComponent(_ref) {
  var children = _ref.children,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "end" : _ref$placement,
      text = _ref.text,
      visible = _ref.visible,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_antd.Badge.Ribbon, {
    text: text,
    placement: placement,
    className: " ".concat(visible ? "iiht-badge-ribbon" : "display-none", " ").concat(className)
  }, children);
};

var _default = BadgeComponent;
exports["default"] = _default;